import React, { useEffect, useContext } from 'react'
import moment from 'moment'
import { UserContext } from '../../../Providers/UserContext/UserContex'
import { Box } from '@mui/material'
import { TimersContext } from '../../../Providers/Timers/TimersContext'

function OneContador() {
    const { addTimer, rmTimer } = useContext(TimersContext)
    const { check } = useContext(UserContext)

    useEffect(() => {
        if (check.estado_jornada == 1 || check.estado_jornada == 3) {
            addTimer('timerJornada', moment(check.dt_checkin).format('X'))
            let el = document.getElementById('timerJornada')
            if (el) { el.innerHTML = ''; el.style.display = 'inline-block' }
        } else if (check.estado_jornada == 2 || check.estado_jornada == 4) {
            let el = document.getElementById('timerJornada')
            if (el) { el.innerHTML = ''; el.style.display = 'none' }
            rmTimer('timerJornada', false)
        }
    }, [check])

    return (
        <Box component={'div'} id="timerJornada" style={{ fontSize: '17px', textShadow: '1px 1px black', width: '120px', height: '32px', paddingTop: '7px', textAlign: 'right' }}/>
    )
}

export default OneContador
